import { render, staticRenderFns } from "./AIknowledgeBase.vue?vue&type=template&id=1a0b07f0&scoped=true&"
import script from "./AIknowledgeBase.vue?vue&type=script&lang=js&"
export * from "./AIknowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./AIknowledgeBase.vue?vue&type=style&index=0&id=1a0b07f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b07f0",
  null
  
)

export default component.exports